module.exports = __webpack_public_path__ + "static/media/service.87c9c82a.svg";